/**
 * Convert an object to an array of strings.
 */
export function toStringArray(obj: Record<string, any>): string[] {
  return Object.entries(obj).reduce(
    (acc, [k, v]) => {
      if (v === undefined) {
        return acc;
      }

      acc.push(k, v.toString());

      return acc;
    },
    <string[]>[],
  );
}
